
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton } from '@/components';
import { useAvatarColorEdit } from '@/modules/avatar/color/model/edit';
import { ROUTE_NAME_AVATAR } from '@/modules/avatar/router';

export default defineComponent({
    name: ROUTE_NAME_AVATAR.COLOR.EDIT,
    components: { AppFormRow, AppInput, AppCard, AppButton },
    setup() {
        const { model, v$, actions } = useAvatarColorEdit();

        onMounted(() => {
            actions.fetch();
        });

        return { v$, model, actions };
    }
});
